<template>
  <div>
    <q-dialog
      :visible="isVisible"
      :title="title"
      width="1200px"
      :innerScroll="false"
      :loading="loadingButtom"
      :showFooter="false"
      @close="onCancel"
      v-esc-close
    >
      <div class="content">
        <div v-if="detailData.relationSpu" class="relation-spu">
          <span class="relation-spu-label">关联SPU：</span>
          <span>{{ detailData.relationSpu }}</span>
        </div>
        <div class="section-box">
          <div class="section-content" v-html="detailData.adjustDetailDesc || '<p></p>'"></div>
        </div>
      </div>
    </q-dialog>
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close
      ><imgShow :imgList="imgList"></imgShow
    ></el-dialog>
  </div>
</template>

<script>
import imgShow from "@/views/components/imgShow";
export default {
  components: { imgShow },
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    appealReason: [String, Object],
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "设计图调整详情";
    },
    detailData() {
      if (typeof this.appealReason === 'string') {
        return {
          adjustDetailDesc: this.appealReason,
          relationSpu: '',
        };
      }
      return this.appealReason || {};
    },
  },
  data() {
    return {
      loadingButtom: false,
      imgFormVisible: false,
      imgList: [],
      htmlImgList: [],
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    imgClick(e) {
      let img = e.elems[0].currentSrc;
      this.imgFormVisible = true;
      this.imgList = [img];
    },

  },
};
</script>

<style lang="stylus" scoped>

.content {
  max-height: 700px
  overflow-y: auto
  overflow-x: hidden
  padding 0 8px
}

.relation-spu
  margin-bottom 12px
  font-size 14px

.relation-spu-label
  color #606266
  font-weight 600

.section-box
  margin-bottom 16px
  border 1px solid #ebeef5
  border-radius 4px
  overflow hidden
  background #fff

.section-title
  padding 10px 12px
  background #f7f8fa
  border-bottom 1px solid #ebeef5
  font-size 14px
  font-weight 600

.section-content
  min-height 160px
  padding 12px

>>> .section-content img
  max-width 100%

>>> .el-dialog {
  margin: 50px auto !important
}

</style>
